// Waypoint360: English locale for the DJI Pilot 2 webview. Keep keys in sync with fr.ts.
export default {
  attribution: {
    checking: 'Checking attribution…',
    linkedTitle: 'Flight attached',
    linkedBody: 'This flight is being recorded for {org}.',
    pendingTitle: 'Flight not attached',
    // Never say the flight is lost: it IS recorded. Saying otherwise would make a pilot cancel
    // a perfectly good flight.
    pendingBody: 'No flight is planned for this drone. The flight will be recorded, but not attached to a mission. Plan it in the app and it will attach by itself.',
    pendingSeveral: 'Several planned flights match this drone. The flight will be recorded, but not attached. Set the start time of your flights in the app.',
    rejectedTitle: 'Drone not registered',
    rejectedBody: 'This drone (SN {sn}) is in no fleet. Declare it in the Waypoint360 app to record its flights.',
    disconnectedTitle: 'Drone disconnected',
    disconnectedBody: 'No aircraft is connected to this remote. Power on the drone to record its flight.',
  },
  // Live status pushed into the native DJI account card (the OpenPlatform zone). The emoji carries
  // the colour — the plain description text cannot be styled.
  marker: {
    collecting: '🟢 Recording active',
    pending: '🟠 Awaiting attachment',
    offline: '🔴 Recording interrupted',
  },
  boot: {
    onlyRemoteTitle: 'Remote controller access only',
    // {app} is the (bold) "DJI Pilot 2" product name, injected via <i18n-t>.
    onlyRemoteHint: 'This page opens from {app} on your remote controller, through the Waypoint360 cloud platform. It has no use in a web browser.',
    licenseErrorTitle: 'License not validated',
    licenseErrorHint: 'The Waypoint360 license could not be verified on this device.',
    connectErrorTitle: 'Connection failed',
    connecting: 'Connecting to Waypoint360…',
  },
  errors: {
    apiModuleLoad: 'Failed to load the API module.',
    authRejected: 'Authentication rejected.',
    unknown: 'Unknown error.',
    remoteDataUnavailable: 'Data unavailable, please restart the remote controller.',
  },
  home: {
    logout: 'Log out',
    collecting: 'Collecting',
    connecting: 'Connecting…',
    exit: 'Exit',
    cancel: 'Cancel',
    exitConfirm: 'After exiting, data will no longer sync between DJI Pilot and Waypoint360.',
    serialNumbers: 'Serial numbers',
    remoteSn: 'Remote controller SN',
    droneSn: 'Drone SN',
    settings: 'Settings',
    droneBinding: 'Drone binding',
    bound: 'Drone linked',
    unbound: 'Drone not linked',
    mediaUpload: 'Media upload',
  },
}
